import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    success: false,
    loading: false,
    data: null,
    error: null
};

const UserEnrollmentFailedDevicesSlice = createSlice({
    name: 'UserEnrollmentFailedDevicesService',
    initialState,
    reducers: {
        UserEnrollmentFailedDevicesServiceInit(state) {
            state.loading = true;
            state.error = null;
            state.success = false;
            state.data = null;
        },
        UserEnrollmentFailedDevicesServiceSuccess(state, action) {
            state.loading = false;
            state.success = true;
            state.data = action.payload;
            state.error = null;
        },
        UserEnrollmentFailedDevicesServiceFailure(state, action) {
            state.loading = false;
            state.success = false;
            state.error = action.payload;
            state.data = null;
        },
        UserEnrollmentFailedDevicesServiceReset: () => initialState
    }
});

export const {
    UserEnrollmentFailedDevicesServiceInit,
    UserEnrollmentFailedDevicesServiceSuccess,
    UserEnrollmentFailedDevicesServiceFailure,
    UserEnrollmentFailedDevicesServiceReset
} = UserEnrollmentFailedDevicesSlice.actions;

export default UserEnrollmentFailedDevicesSlice.reducer;